import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import clickOutside from 'react-click-outside';
import { grey25, white } from '@zocdoc/branding/colors';
import { LayoutPropTypes, LOGIN_STATE, USER_TYPE } from '../../constants';
import { DropdownLinks, LOCALIZED_STRINGS } from '../constants';
import { AppointmentList } from './appointment/appointment-list';
import NotificationCount from './NotificationCount';
import NotificationList from './notification/notification-list';
import { Link } from '../../../link';
import { FormattedMessage } from 'react-intl';
import { DropdownHeader } from '../dropdown';
import { FontFamily } from '../../../typography';

const dataProdGuid = 'ec27c86b';

export class NotificationMenuView extends Component {
    static propTypes = {
        count: PropTypes.number.isRequired,
        closeDropdown: PropTypes.func.isRequired,
        loginState: LayoutPropTypes.loginState.isRequired,
        isOpen: PropTypes.bool.isRequired,
        toggleDropdown: PropTypes.func.isRequired,
        userType: PropTypes.number,

        onNotificationClick: PropTypes.func,
        onUpcomingAppointmentClick: PropTypes.func,
        onSeeAllNotificationsClick: PropTypes.func,
        onClickSoftLoggedInLogin: PropTypes.func,
    };

    render() {
        const {
            count,
            isOpen,
            toggleDropdown,
        } = this.props;

        return (
            <NotificationDropdown
                ref={container => { this.container = container; }}
                data-prod-guids={`notification-dropdown-button:[${dataProdGuid}]`}
                data-test="notification-dropdown-button"
                onClick={e => this.handleClickContainer(e)}
            >
                <NotificationCount
                    active={isOpen}
                    count={count}
                    onClick={toggleDropdown}
                />

                {this.renderDropdown()}
            </NotificationDropdown>
        );
    }

    renderDropdown() {
        const {
            loginState,
            isOpen,
            onUpcomingAppointmentClick,
            onNotificationClick,
            onSeeAllNotificationsClick,
            onClickSoftLoggedInLogin,
            userType,
        } = this.props;

        if (!isOpen) {
            return;
        }
        if (loginState === LOGIN_STATE.SoftLoggedIn) {
            const loginLink = userType === USER_TYPE.Provider
                ? DropdownLinks.providerSignin : DropdownLinks.patientSignin;

            return (
                <Dropdown data-test="notification-dropdown">
                    <SoftLoginHeader>
                        <FormattedMessage {...LOCALIZED_STRINGS.Notifications} />
                    </SoftLoginHeader>
                    <SoftLoginLinkContainer>
                        <SignInLink
                            beforeClick={onClickSoftLoggedInLogin}
                            data-test="header-softloggedin-login-link"
                            href={loginLink}
                            title="signin"
                        >
                            <FormattedMessage {...LOCALIZED_STRINGS.SoftLoginMessage} />
                        </SignInLink>
                    </SoftLoginLinkContainer>
                </Dropdown>
            );
        }

        return (
            <Dropdown
                data-prod-guids={`notification-dropdown:[${dataProdGuid}]`}
                data-test="notification-dropdown"
            >
                <AppointmentList
                    onUpcomingAppointmentClick={onUpcomingAppointmentClick}
                />
                <NotificationList
                    onNotificationClick={onNotificationClick}
                    onSeeAllNotificationsClick={onSeeAllNotificationsClick}
                />
            </Dropdown>
        );
    }

    handleClickContainer(e) {
        // Only close if the click is on the container itself, not anything else inside
        if (e.target === this.container) {
            if (this.props.isOpen) {
                this.props.closeDropdown();
            }
        }
    }

    handleClickOutside() {
        if (this.props.isOpen) {
            this.props.closeDropdown();
        }
    }
}

const Dropdown = styled.div`
    position: absolute;
    right: 0;
    top: 40px;
    width: 320px;
    z-index: 99;
    border: 1px solid ${grey25};
`;

const NotificationDropdown = styled.div`
    position: relative;
`;

const SoftLoginHeader = styled(DropdownHeader)`
    height: 37px;
    border: none;
`;

const SoftLoginLinkContainer = styled.div`
    background-color: ${white};
    box-sizing: border-box;
    height: 47px;
    width: 318px;
    padding: 13px 15px 16px 15px;
`;

const SignInLink = styled(Link)`
    font: 15px/15px ${FontFamily.SharpSansSemibold};
`;

export default clickOutside(NotificationMenuView);
